import { clearAuth, clearUserInfo } from '@/auth'
import { t } from '@/locales'
import { Loading, Modal } from '@tellus/component'
import { resetRouter, useRouter } from '@tellus/router'
import { isFunction } from '@tellus/utils'

/**
 * @description: Process error request
 * @param {*} error
 * @param {*} requestOptions
 */
export function afterRequestCatchHook(error, requestOptions) {
  Loading.close()
  const { message } = error
  const { errCallback, isSkipRequestCatchHook } = requestOptions

  if (!isSkipRequestCatchHook && error.code != 'CANCEL') {
    Modal.showError('', error.status === 401 ? t('message.login.timeout') : error.data?.Messages[0].Message || message)
      .then(() => {
        if (error.status === 401) {
          clear()
          useRouter().push({ path: '/Login' })
        }
      })
      .catch(() => {})
  }

  if (errCallback && isFunction(errCallback)) {
    errCallback(error)
  }
}
function clear() {
  clearUserInfo()
  clearAuth()
  resetRouter()
}
